import { useState } from 'react'
import Modal from '@mui/material/Modal'
import { IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useDispatch } from 'react-redux'
import { updateProfile } from '../../../features/authSlice'
import { toastHelper } from '../../../util/toastHelper'

import { GetStartedModal } from '../../popups/profileSettingsModals/GetStartedModal'
import { BusinessTypeModal } from '../../popups/profileSettingsModals/BusinessTypeModal'
import { NumEmployeesModal } from '../../popups/profileSettingsModals/NumEmployeesModal'
import { AddPhotoModal } from '../../popups/profileSettingsModals/AddPhotoModal'
import { SocialProfilesModal } from '../../popups/profileSettingsModals/SocialProfilesModal'
import VendorModal from '../../molecules/VenderModal/VendorModal'
import style from '../../molecules/VenderModal/VendorModal.module.scss'
import Capacity from '../../popups/profileSettingsModals/Capacity'
import Services from '../../popups/profileSettingsModals/Services'
import { BusinessDescriptionModal } from '../../popups/profileSettingsModals/BusinessDescriptionModal'
import { STEP_FIELDS } from '../../../util/constants'

export const CompleteProfileModal = ({
	open,
	handleClose,
	formData,
	setFormData,
	handleFileChange,
	step,
	setStep,
}) => {
	const dispatch = useDispatch()
	const [saving, setSaving] = useState(false)

	// Fields to send per step (step-only payload to avoid overwriting other steps)
	const buildUpdatesForStep = (isFinalStep) => {
		const fields = STEP_FIELDS[step] || []
		const updates = {}
		fields.forEach((key) => {
			if (formData[key] !== undefined && formData[key] !== null) {
				if (key === 'instagramLink' || key === 'tiktokLink' || key === 'facebookLink' || key === 'websiteLink') {
					updates[key] = (formData[key] || '').trim()
				} else if (key === 'businessTypes') {
					updates.businessTypes = formData.businessTypes ?? []
				} else if (key === 'businessDescription') {
					updates.businessDescription = (formData.businessDescription || '').trim()
				} else updates[key] = formData[key]
			}
		})
		if (isFinalStep) {
			updates.profileCompleted = true
		}
		return updates
	}

	// Handler to update profile at each step
	const handleUpdateProfile = (onSuccess, isFinalStep = false) => {
		const updates = buildUpdatesForStep(isFinalStep)

		setSaving(true)
		dispatch(updateProfile(updates))
			.then((result) => {
				if (result.payload?.success) {
					if (typeof onSuccess === 'function') {
						onSuccess()
					}
					if (isFinalStep) {
						handleClose()
					}
				} else {
					toastHelper(result.payload?.message || "Couldn't save – please try again", 'error')
				}
			})
			.catch((error) => {
				console.error('Error updating profile:', error)
				toastHelper("Couldn't save – please try again", 'error')
			})
			.finally(() => {
				setSaving(false)
			})
	}
	const renderCard = () => {
		switch (step) {
			case 0:
				return (
					<GetStartedModal
						setStep={setStep}
						formData={formData}
						setFormData={setFormData}
					/>
				)
			case 1:
				return (
					<BusinessTypeModal
						step={step}
						setStep={setStep}
						formData={formData}
						setFormData={setFormData}
						onUpdateProfile={handleUpdateProfile}
						saving={saving}
					/>
				)
			case 2:
				return (
					<BusinessDescriptionModal
						step={step}
						setStep={setStep}
						formData={formData}
						setFormData={setFormData}
						onUpdateProfile={handleUpdateProfile}
						saving={saving}
					/>
				)

			case 3:
				return (
					<NumEmployeesModal
						step={step}
						setStep={setStep}
						formData={formData}
						setFormData={setFormData}
						onUpdateProfile={handleUpdateProfile}
						saving={saving}
					/>
				)
			case 4:
				return (
					<Services
						step={step}
						setStep={setStep}
						formData={formData}
						setFormData={setFormData}
						onUpdateProfile={handleUpdateProfile}
						saving={saving}
					/>
				)
			case 5:
				return (
					<Capacity
						step={step}
						setStep={setStep}
						formData={formData}
						setFormData={setFormData}
						onUpdateProfile={handleUpdateProfile}
						saving={saving}
					/>
				)
			case 6:
				return (
					<AddPhotoModal
						step={step}
						setStep={setStep}
						formData={formData}
						setFormData={setFormData}
						handleFileChange={handleFileChange}
						onUpdateProfile={handleUpdateProfile}
						saving={saving}
					/>
				)
			case 7:
				return (
					<SocialProfilesModal
						step={step}
						setStep={setStep}
						formData={formData}
						setFormData={setFormData}
						onUpdateProfile={handleUpdateProfile}
						saving={saving}
					/>
				)
		}
	}

	return (
		<Modal
			open={open}
			sx={{
				display: 'flex',
				height: '100dvh',
				maxHeight: '100dvh',
				minHeight: '600px',
			}}
		>
			<>
				<VendorModal className={`${style.CommonSectionModals}`}>
					<IconButton
						data-cy="close"
						sx={{
							color: 'white',
							position: 'absolute',
							backgroundColor: '#ffffff',
							borderRadius: '50%',
							padding: '12px',
							right: '1rem',
							top: '1rem',
							zIndex: 3,
							'@media (max-width: 499px)': {
								padding: '8px',
							},
						}}
						onClick={handleClose}
					>
						<CloseIcon
							sx={{
								color: '#282828',
								width: '20px',
								height: '20px',
								aspectRatio: '1/1',
							}}
						/>
					</IconButton>
					{renderCard()}
				</VendorModal>
			</>
		</Modal>
	)
}
